const fonts = {
  //add fonts here
  fontStackHeader: 'font-family: canada-type-gibson, helvetica, sans-serif;',
  fontStackBody: 'font-family: museo-sans, helvetica, sans-serif;'
  //
};
const colors = {
  brand: '#4a90e2',
  purple: '#a957fc',
  blue: '#4a90e2',
  inactiveBlue: '#DDE7F4',
  azure: '#306AB0',
  indigo: '#397BCA',
  toreaBay: '#0d4a92',
  black: 'black',

  red: '#FF3161',
  orange: '#FF7A00',
  darkOrange: '#FF8B20',
  // blueBgRed: '#9F0606', // not used in this project
  green: '#00BC7C',
  graphicGreen: '#04F4A2',
  yellow: '#FFBC00',
  cannonPink: '#9C5075',

  //greys
  mercury: '#e2e2e2',
  white: '#ffffff',
  concrete: '#f3f3f3',
  dustyGray: '#969696',
  dustierGray: '#bebebe',
  alto: '#d1d1d1',
  darkGray: '#acacac',

  //password
  touched: '#ff3161',
  error: '#ffea00',
  warning: '#04f4a2'
};

const fontSize = {
  h8: '1.3rem',
  h9: '1.2rem'

  // h6:
  // h7
};

const dropShadow = {
  defaultDropShadow: 'box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.15);',
  contentDropShadow: 'box-shadow: rgba(0, 0, 0, 0.77) 0px 0px 8px -4px;',
  topDropShadow: 'box-shadow: 0px -2px 4px rgba(134, 134, 134, 0.36);',
  bottomDropShadow: 'box-shadow: rgba(114, 113, 113, 0.26) 2px 3px 4px 0px;',
  tabletHeaderShadow: 'box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.16);',
  tooltipRectangleDropShadow:
    'filter: drop-shadow(0px 1px 1px rgba(0, 0, 0, 0.15));',
  sidebarTooltipDropShadow: `filter: drop-shadow(0px 2px 2px ${colors.darkGray});`
};

const height = {};

const width = {};

export default function theme(extras) {
  return {
    ...fonts,
    ...colors,
    ...fontSize,
    ...dropShadow,
    ...height,
    ...width,
    defaultBorder: `1px solid ${colors.mercury}`,
    ...extras
  };
}
